import React from 'react';

function SalarySelectField() {
  return '';
}

export default SalarySelectField;
